import React from "react"
import types from "prop-types"
import clsx from "clsx"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const EllipsisIcon = ({
  className = "", width = undefined, height = undefined, onClick = () => {}, ariaHidden = false, ref = undefined,
}) => (
  <span ref={ref}>
    <SvgSpriteIcon
      className={clsx(className, "cursor-pointer")}
      iconName="ellipsis"
      width={width}
      height={height}
      onClick={onClick}
      ariaHidden={ariaHidden}
    />
  </span>
)

EllipsisIcon.propTypes = {
  className: types.string,
  width: types.number,
  height: types.number,
  onClick: types.func,
  ariaHidden: types.bool,
  ref: types.oneOfType([types.func, types.object]),
}

EllipsisIcon.displayName = "EllipsisIcon"

export default EllipsisIcon
